import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import { categories, articles } from '@/mocks/data';

const categoryTabs = [
  { value: 'all', label: '全部' },
  { value: 'latest-address', label: '最新地址' },
  { value: 'access-guide', label: '访问指南' },
  { value: 'popular-recommend', label: '热门推荐' },
  { value: 'new-releases', label: '最新上架' },
  { value: 'genres', label: '分类浏览' },
  { value: 'faq-help', label: '帮助中心' },
];

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: 'JM漫画分类浏览 - jmcomic-zzz.one',
  url: 'https://jmcomic-zzz.one/category',
  description: '按分类浏览JM漫画相关文章，包括最新地址、访问指南、热门推荐、最新上架、分类浏览和帮助中心。',
  isPartOf: { '@id': 'https://jmcomic-zzz.one/#website' },
};

export default function Category() {
  const [activeTab, setActiveTab] = useState('all');

  const filteredArticles = activeTab === 'all'
    ? articles
    : articles.filter((a) => a.category === activeTab);

  const currentCategory = categoryTabs.find((t) => t.value === activeTab);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />

      <main>
        <section className="pt-24 pb-8 md:pt-28 md:pb-10 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '分类浏览' },
              ]}
            />
            <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-4 mb-2">
              分类浏览
            </h1>
            <p className="text-foreground-600 text-sm">
              按分类查找JM漫画相关文章，快速定位您需要的内容
            </p>
          </div>
        </section>

        <section className="py-8 md:py-10 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-2 flex-wrap mb-8">
              {categoryTabs.map((tab) => (
                <button
                  key={tab.value}
                  onClick={() => handleTabChange(tab.value)}
                  className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    activeTab === tab.value
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 mb-6">
              快速分类入口
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => handleTabChange(cat.slug)}
                  className="flex flex-col items-center p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-2">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">
                    {cat.name}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}